export default __webpack_public_path__ + "static/media/f6.c3ab6e95.svg";